import { Box, Container, Stack, Typography, useTheme } from '@mui/material';
import { useSettingsContext } from 'src/components/settings';
import { useLocales } from 'src/locales';

function HomeMonetarySystem() {
  const theme = useTheme();
  const { t } = useLocales();
  const settings = useSettingsContext();

  return (
    <Container
      maxWidth="lg"
      sx={{
        backgroundImage: 'url(/assets/images/home/token-page/monetary-system_bg.png)',
        backgroundRepeat: 'no-repeat, no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '60%',
      }}
    >
      <Stack sx={{ py: { xs: 5, md: 10 } }}>
        <Typography variant="h2" color="primary" textTransform="uppercase" align="center">
          {t('walkup_lang_184')}
        </Typography>

        <Typography width={{ xs: '100%', md: '50%' }} mt={4}>
          {t('walkup_lang_185')}
        </Typography>

        <Stack>
          <Box
            component="img"
            src={`./assets/images/home/token-page/monetary-system_${settings.themeMode}.png`}
          />
        </Stack>
      </Stack>
    </Container>
  );
}

export default HomeMonetarySystem;
